const getOrderLineUnits = ({ orderLine, value, index, caloricUnitsSupport }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (index !== undefined) {
    const indexOrderLine = orderLine ? orderLine[index] : null;
    if (indexOrderLine) {
      return caloricUnitsSupport && indexOrderLine['Calories Per Unit']
        ? Math.ceil(indexOrderLine.Units * indexOrderLine['Calories Per Unit'] / 100) : indexOrderLine.Units;
    }
    return null;
  }
  return orderLine
    ? orderLine.map(item => caloricUnitsSupport && item['Calories Per Unit']
        ? Math.ceil(item.Units * item['Calories Per Unit'] / 100) : item.Units).join(', ')
    : null;
};

export default getOrderLineUnits;



// WEBPACK FOOTER //
// ./src/utils/print/getOrderLineUnits.js